import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#232323] group-[.toaster]:text-white group-[.toaster]:border-[#262626] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#CCCCCC]",
          actionButton:
            "group-[.toast]:bg-[#4ECDC4] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#262626] group-[.toast]:text-[#CCCCCC]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
